import { ThemeConfig } from './types'
import { typography, breakpoints, components } from './base.theme'

export const adventureTheme: ThemeConfig = {
  id: 'adventure',
  name: 'Adventure',
  description: 'Nature-inspired adventure theme',
  preview: {
    primaryColor: '#2D6B5F',
    secondaryColor: '#D4823B',
  },
  light: {
    palette: {
      mode: 'light',
      primary: {
        main: '#2D6B5F', // Teal green from template
        light: '#4A8A7C',
        dark: '#1E4D44',
        contrastText: '#ffffff',
      },
      secondary: {
        main: '#D4823B', // Warm orange/brown from badges
        light: '#E09D5F',
        dark: '#B6682A',
        contrastText: '#ffffff',
      },
      background: {
        default: '#F5F1E8', // Cream/beige background
        paper: '#FFFFFF',
      },
      success: {
        main: '#5A8F60', // Muted green for success states
      },
      info: {
        main: '#6BA4A8', // Teal blue from badges
      },
      warning: {
        main: '#D4823B',
      },
      error: {
        main: '#C75B5B',
      },
    },
    typography,
    breakpoints,
    components,
  },
  dark: {
    palette: {
      mode: 'dark',
      primary: {
        main: '#66bb6a',
        light: '#98ee99',
        dark: '#338a3e',
        contrastText: '#000000',
      },
      secondary: {
        main: '#ffa726',
        light: '#ffd95b',
        dark: '#c77800',
        contrastText: '#000000',
      },
      background: {
        default: '#1a1a1a',
        paper: '#2a2a2a',
      },
    },
    typography,
    breakpoints,
    components,
  },
}
